import React, { useState } from 'react';
import { useSelector } from "react-redux";
import NoResultFound from "../../../../common/NoResultFound";
import Message from '../../messageBox/Messages/Message';
import moment from 'moment';
import DateDivider from '../../ChatMessage/DateDivider';
import { Skeleton } from '@mui/material';
import Paginate from '../../../../common/Paginate';
import { GetQueryParam } from '../../../../utils/common';
import { useDispatch } from 'react-redux';
import { getSearchConversationMessages } from '../../../../actions/conversations';
import { useNavigate } from 'react-router-dom';



export const SearchedMessage = ({ searchTerm }) => {
    const openedConversationId = useSelector((state) => state.conversations.openedConversationId);
    const searchedMessages = useSelector((state) => state.chat.searchedMessages)
    const metaData = useSelector((state) => state.chat.metaData)

    const isSearchMessageLoading = useSelector((state) => state.loading.isSearchMessageLoading);

    const defaultPage = 1;
    const defaultRowsPerPage = 50;
    const [page, setPage] = useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tab = GetQueryParam("tab")
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData)
    const onPageChange = (limit, page) => {
        let offset = 0
        if (page === 1) {
            offset = 0
        } else {
            offset = (page - 1) * limit;
        }
        if (searchTerm?.length > 0) {
            let payload = {
                _id: openedConversationId,
                limit: limit,
                offset,
                query: searchTerm
            }
            dispatch(getSearchConversationMessages(payload))
        }
    }

    const isDateAreSame = (a, b) => {
        return a && b && moment(a).format('dd/MM/Y') === moment(b).format('dd/MM/Y');
    };


    if (searchedMessages?.length === 0 && !isSearchMessageLoading) {
        return (<div className='px-2'>
            <NoResultFound message="No Message Found " paddingy="py-2" paddingx="px-2" />
        </div >)
    }

    const messageOnclick = (conversationId, messageId) => {
        var today = new Date();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        navigate(`/chats/${conversationId}?tab=${tab}&messageId=${messageId}&t=${time}`);
    }

    const messages = searchedMessages?.[openedConversationId] || [];
    return <>
        {isSearchMessageLoading ?
            <MessageLoadingComp />
            : <div className='overflow-scroll h-[94.3%]  bg-scogoeee ' >

                {messages.map((msg, index) => {

                    let isDateChanged = true;

                    if (msg.created_at && messages[index - 1] && messages[index - 1].created_at) {
                        isDateChanged = !isDateAreSame(msg.created_at, messages[index - 1].created_at);
                    }

                    return (
                        <React.Fragment key={msg.id}>
                            {isDateChanged && (
                                <DateDivider timestamp={msg.created_at} borderWidth={"w-4/12"} timeWidth={"w-6/12"} />
                            )}
                            <Message
                                message={msg}
                                side={newLoggedUserData?.user?.id === msg.author_id ? 'right' : 'left'}
                                type={msg?.mime_type}
                                showMessageAction={false}
                                showReplyIcon={false}
                                messageOnclick={messageOnclick}
                                isSearchMessage={true}
                                showJumbIcon={true}
                                onClickReplyMessage={() => { }}
                            />
                        </React.Fragment>
                    );
                })}

            </div>
        }

        <div className='border-t-1 border-gray-400 bg-white' >

            <Paginate count={metaData.total_count} onPageChange={(limit, page) => {
                setRowsPerPage(limit)
                setPage(page);
                onPageChange(limit, page)
            }} entriesPerPage={rowsPerPage ? rowsPerPage : 0} setRowsPerPage={setRowsPerPage} page={page} rowsPerPageOptions={false} style={{
                ".MuiTablePagination-toolbar": {
                    minHeight: "20px !important",
                    justifyContent: "center"
                },
                ".MuiTablePagination-spacer": {
                    display: "none"
                },
                ".css-levciy-MuiTablePagination-displayedRows": {
                    fontSize: "1.2rem"
                }
            }} />
        </div>

    </>
}


const MessageLoadingComp = () => {
    return <div className='px-2 h-[92.3%] bg-scogoeee' >
        <div className='pr-[20%] mt-4'>
            <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={"80%"} height={100} animation='wave' />
        </div>

        <div className='pl-[20%] mt-4'>
            <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={"full"} height={70} animation='wave' />
        </div>
        <div className='pr-[20%] mt-4'>
            <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={"80%"} height={100} animation='wave' />
        </div>

        <div className='pl-[20%] mt-4'>
            <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={"full"} height={70} animation='wave' />
        </div>
        <div className='pr-[20%] mt-4'>
            <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={"80%"} height={100} animation='wave' />
        </div>

        <div className='pl-[20%] mt-4'>
            <Skeleton sx={{ background: 'rgb(221,221,221)' }} variant='rectangular' width={"full"} height={70} animation='wave' />
        </div>
    </div>
}